"use client";

import { c as _c } from "react/compiler-runtime";
import { useWallet } from "@solana/wallet-adapter-react";
import { useCallback } from "react";
import { useConfig, useDisconnect as useWagmiDisconnect } from "wagmi";
import { AccountActions } from "../../stores/accountStore";
import { useConnectors } from "./useConnectors";
import { useLogout } from "./useLogout";
import { useSolanaConnections } from "./useSolanaConnections";
export function useDisconnect() {
  const $ = _c(13);
  const {
    isPending,
    disconnectAsync: disconnectWagmiAsync
  } = useWagmiDisconnect();
  const {
    connectors
  } = useConnectors();
  const {
    disconnect: disconnectSolana
  } = useWallet();
  const {
    resetConnection: resetSolanaConnection
  } = useSolanaConnections();
  const {
    logout
  } = useLogout();
  const wagmiConfig = useConfig();
  let t0;
  if ($[0] !== wagmiConfig) {
    t0 = async () => {
      const state = wagmiConfig.state;
      const connections = state.connections;
      let current = state.current;
      for (const [, connection] of connections) {
        const connector = connection.connector;
        const isAuthorized = connector.isAuthorized ? await connector.isAuthorized() : false;
        if (isAuthorized) {
          continue;
        }
        connections.delete(connector.uid);
        if (current === connector.uid) {
          current = null;
        }
      }
      wagmiConfig.setState(x => ({
        ...x,
        connections,
        current
      }));
    };
    $[0] = wagmiConfig;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const revalidate = t0;
  let t1;
  if ($[2] !== connectors || $[3] !== disconnectSolana || $[4] !== disconnectWagmiAsync || $[5] !== logout || $[6] !== resetSolanaConnection || $[7] !== revalidate) {
    t1 = async (connector_0, t2) => {
      const {
        endSession: t3
      } = t2 === undefined ? {} : t2;
      const endSession = t3 === undefined ? true : t3;
      if (connector_0) {
        bb28: switch (connector_0.chainArch) {
          case "EVM":
            {
              await disconnectWagmiAsync({
                connector: connector_0.baseConnector
              });
              if (connectors.filter(c => c.id !== connector_0.id).every(_temp) && endSession) {
                AccountActions.setActiveChainArch("SVM");
              }
              break bb28;
            }
          case "SVM":
            {
              await disconnectSolana();
              resetSolanaConnection(connector_0.id);
              if (endSession) {
                AccountActions.setActiveChainArch("EVM");
              }
            }
        }
      } else {
        await Promise.all(connectors.filter(_temp2).flatMap(connector_1 => {
          if (connector_1.chainArch !== "EVM") {
            return [];
          }
          return disconnectWagmiAsync({
            connector: connector_1.baseConnector
          });
        }));
        await disconnectSolana();
        resetSolanaConnection();
      }
      if (endSession) {
        await logout();
      }
      await revalidate();
    };
    $[2] = connectors;
    $[3] = disconnectSolana;
    $[4] = disconnectWagmiAsync;
    $[5] = logout;
    $[6] = resetSolanaConnection;
    $[7] = revalidate;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  const disconnect = t1;
  let t2;
  if ($[9] !== connectors || $[10] !== disconnect || $[11] !== isPending) {
    t2 = {
      connectors,
      disconnect,
      isDisconnecting: isPending
    };
    $[9] = connectors;
    $[10] = disconnect;
    $[11] = isPending;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}
function _temp2(c_1) {
  return c_1.isConnected();
}
function _temp(c_0) {
  return !c_0.isConnected();
}